const LAUNCH_COMPANY_STORAGE_KEY = "clinic.launchRequestedCompanyId";
const LOGIN_HANDOFF_PENDING_KEY = "clinic.loginHandoffPending";

/** Set when auth handoff lands on /app-redirect; cleared after org pick or single-org entry. */
export function markLoginHandoffPending(): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(LOGIN_HANDOFF_PENDING_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function isLoginHandoffPending(): boolean {
  if (typeof sessionStorage === "undefined") {
    return false;
  }
  try {
    return sessionStorage.getItem(LOGIN_HANDOFF_PENDING_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearLoginHandoffPending(): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.removeItem(LOGIN_HANDOFF_PENDING_KEY);
  } catch {
    /* ignore */
  }
}

/** Ask Aya My Apps uses readable ?token=; auth portal clinic login uses encrypted ?q=. */
export function isAskAyaClinicLaunch(input: {
  token?: string | null;
  q?: string | null;
  launchSource?: string | null;
  companyId?: string | null;
  userId?: string | null;
}): boolean {
  if (input.launchSource?.trim().toLowerCase() === "aya") {
    return true;
  }
  return !!(
    input.token?.trim() &&
    !input.q?.trim() &&
    input.companyId?.trim() &&
    input.userId?.trim()
  );
}

/** Remember org chosen on Ask Aya My Apps so Clinic must not auto-switch to MVP. */
export function setLaunchRequestedCompanyId(companyId: string): void {
  const id = companyId?.trim();
  if (!id || typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(LAUNCH_COMPANY_STORAGE_KEY, id);
  } catch {
    /* ignore quota / private mode */
  }
}

export function getLaunchRequestedCompanyId(): string | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  try {
    return sessionStorage.getItem(LAUNCH_COMPANY_STORAGE_KEY)?.trim() || null;
  } catch {
    return null;
  }
}

export function clearLaunchRequestedCompanyId(): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.removeItem(LAUNCH_COMPANY_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function shouldSkipPreferredCompanyAutoSelect(): boolean {
  return !!getLaunchRequestedCompanyId();
}

/** My Apps launch: stay on the requested org even without a Clinic license. */
export function isActiveLaunchRequestedCompany(
  companyId: string | null | undefined
): boolean {
  const requested = getLaunchRequestedCompanyId();
  if (!requested || !companyId?.trim()) {
    return false;
  }
  return requested.toLowerCase() === companyId.trim().toLowerCase();
}

export function shouldBypassClinicLicenseForLaunch(
  companyId: string | null | undefined
): boolean {
  return isActiveLaunchRequestedCompany(companyId);
}
